<template>
  <div>
    <el-card class="box-card" body-style="min-height:70vh;">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="会员分类：" prop="region">
            <el-select v-model="searchForm.region" placeholder="请选择" class="mt-search-width">
              <el-option label="全部" value="0"></el-option>
              <el-option v-for="(item,index) in memberLeveTypeArr" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="等级名称：" prop="name">
            <el-input v-model="searchForm.name" placeholder="请输入会员等级名称搜索" class="mt-search-width"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-button @click="toAdd('')" size="small" type="primary" class="bg-theme">添加等级</el-button>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="name"
            label="等级名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="name"
            label="归属分类">
            <template slot-scope="scope">
              <span>{{scope.row.type == 1 ? '会员等级' : scope.row.type == 2 ? '员工等级' : '合伙人等级'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="discountRate"
            label="折扣">
          </el-table-column>
          <el-table-column
            align="center"
            prop="minMoney"
            label="升级条件">
            <template slot-scope="scope">
              <span>消费：{{scope.row.minMoney}}-{{scope.row.meetMoney}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="sort"
            label="排序">
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="updateTime"
            label="更新时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="toAdd(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="delBtn(scope.row.id)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryUserMemberLevelPageList, removeUserMemberLevelById } from '@/api/level'
export default {
  name: 'Level',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      baseUrl:this.$baseUrl,
      token:this.$token,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:'',
        region:''
      },
      memberLeveTypeArr: [{
        value: 1,
        label: '会员'
      }, {
        value: 2,
        label: '内部员工'
      }, {
        value: 3,
        label: '合伙人'
      }]
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let type = that.searchForm.region === 0 || that.searchForm.region === '' ? 0 : that.searchForm.region
      let page = that.currentPage
      queryUserMemberLevelPageList({ name: searchName, type: type, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeUserMemberLevelById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    },
    /* 跳转添加 */
    toAdd (infoId) {
      this.$router.push({path: '/level_add', query: {dataId: infoId}})
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/Level.vue